import ActivityDefinition from '@/models/activityDefinition';

export default class ActivityDefinitionState {
  public activityDefinitions?: ActivityDefinition[];
  public jobActivityDefinitions?: ActivityDefinition[];
}
